import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { fmtDate } from "@/lib/utils";
import { toast } from "sonner";
import { RotateCcw, Trash2, Archive } from "lucide-react";

const KIND = { customer: "Kunde", request: "Anfrage", booking: "Buchung", request_message: "Nachricht", request_thread: "Nachrichten-Thread" };

export function AdminArchive({ useData }) {
  const { data, loading, reload } = useData("/admin/archive");
  const [busy, setBusy] = useState("");
  const restore = async (it) => {
    if (!window.confirm(`${KIND[it.kind] || it.kind} „${it.label}“ wiederherstellen?`)) return;
    setBusy(it.id);
    try { const { data: r } = await api.post(`/admin/archive/${it.id}/restore`); toast.success(`Wiederhergestellt: ${Object.entries(r).filter(([, n]) => n).map(([k, n]) => `${n} ${k}`).join(", ") || "nichts (bereits vorhanden)"}`); reload(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); } finally { setBusy(""); }
  };
  const purge = async (it) => {
    if (window.prompt(`Archiveintrag „${it.label}“ endgültig entfernen? Danach ist keine Wiederherstellung mehr möglich.\nZur Bestätigung ENDGUELTIG eingeben:`) !== "ENDGUELTIG") return;
    try { await api.delete(`/admin/archive/${it.id}`, { params: { confirm: "ENDGUELTIG" } }); toast.success("Archiveintrag entfernt"); reload(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  if (loading) return <div className="text-slate-400">Lädt…</div>;
  return (
    <div data-testid="admin-archive">
      <p className="text-sm text-slate-400 mb-4">Gelöschte Datensätze werden hier gesichert und können per Klick wiederhergestellt werden.</p>
      {data.length === 0 && <div className="eb-card p-8 text-center text-slate-500"><Archive className="w-6 h-6 mx-auto mb-2 opacity-50" /> Archiv ist leer</div>}
      <div className="space-y-2">
        {data.map((it) => (
          <div key={it.id} className={`eb-card p-4 flex flex-wrap items-center justify-between gap-3 ${it.restored_at ? "opacity-60" : ""}`} data-testid={`archive-row-${it.id}`}>
            <div>
              <div className="font-head font-semibold flex items-center gap-2 flex-wrap"><span className="eb-badge bg-slate-800 text-slate-300">{KIND[it.kind] || it.kind}</span> {it.label}{it.restored_at && <span className="eb-badge bg-emerald-500/15 text-emerald-400">wiederhergestellt {fmtDate(it.restored_at)}</span>}</div>
              <div className="text-xs text-slate-500 mt-1">Gelöscht am {fmtDate(it.deleted_at)} {it.deleted_at?.slice(11, 16)} · {Object.entries(it.counts).map(([k, n]) => `${n} ${k}`).join(" · ")}</div>
            </div>
            <div className="flex gap-1.5">
              {!it.restored_at && <button onClick={() => restore(it)} disabled={busy === it.id} className="eb-btn-primary !py-1.5 text-xs" data-testid={`archive-restore-${it.id}`}><RotateCcw className="w-3.5 h-3.5" /> Wiederherstellen</button>}
              <button onClick={() => purge(it)} className="eb-btn-ghost !py-1.5 text-xs text-red-400" data-testid={`archive-purge-${it.id}`}><Trash2 className="w-3.5 h-3.5" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
